import request from '@/utils/axios'

// 获取BTC、USDT个人资产
export function personalAssets(data) {
  return request({
    url: '/asset/accountAmountUsableByCoinName',
    method: 'post',
    data,
  })
}

// 用户买入卖出
export function tradingOperation(data) {
  return request({
    url: '/trade/addOrderV2',
    method: 'post',
    data: data,
  })
}

// 获取当前委托
export function currentEntrust(data) {
  return request({
    url: '/trade/currentEntrustList',
    method: 'post',
    data: data,
  })
}

// 获取历史委托
export function historyEntrust(data) {
  return request({
    url: '/trade/historyEntrustList',
    method: 'post',
    data: data,
  })
}

// 用户撤单
export function userDivestment(data) {
  return request({
    url: '/trade/cancelOrder',
    method: 'post',
    data,
  })
}

// 获取币对交易规则
export function fetchPairTradeRules(data) {
  return request({
    url: '/trade/tradeRules',
    method: 'post',
    data,
  })
}

// 交易是否需要密码
export function fetchTradingIsNeedPass(data) {
  return request({
    url: '/trade/isNeedTradePassword',
    method: 'post',
    data,
  })
}

// 划转
export function doTransfer(data) {
  return request({
    url: '/asset/contractTransfer',
    method: 'post',
    data,
  })
}
